import { render, staticRenderFns } from "./TaskReport.vue?vue&type=template&id=b6a87d66&scoped=true"
import script from "./TaskReport.vue?vue&type=script&lang=js"
export * from "./TaskReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a87d66",
  null
  
)

export default component.exports